import { ExternalLink, type ExternalLinkProps } from '@repo/design-system-kit';
import type { DistributiveOmit } from '#types/utils';
import { useZendeskArticle } from '#hooks/use-zendesk-article';

export type FAQLinkProps = DistributiveOmit<ExternalLinkProps, 'href'> & {
  articleSlug: string;
};

export function FAQLink({ articleSlug, ...props }: FAQLinkProps) {
  const href = useZendeskArticle(articleSlug);

  return (
    <ExternalLink
      data-testid={`faq-link-${articleSlug}`}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    />
  );
}
